import apiClient from '@/lib/api-client';

/**
 * h6-5 (M1) — "in één keer goed" per stroom.
 *
 * `ratio` mag `null` zijn: bij een lege noemer weten we het niet, en dan hoort er geen getal te
 * staan dat een oordeel suggereert dat niemand heeft uitgesproken.
 */
export interface M1FlowRegel {
  flow: string;
  attempts: number;
  firstTimeRight: number;
  chainFailures: number;
  abandoned: number;
  ratio: number | null;
}

/** h6-6 (T3): hoe lang een klant erover doet, van uploaden tot ingediend. */
export interface T3Regel {
  flow: string;
  gemeten: number;
  blijvenLiggen: number;
  medianeSeconden: number | null;
  p90Seconden: number | null;
}

/**
 * h7-3: hoeveel van onze kolomvoorstellen de klant moest herstellen, per stroom.
 *
 * Alles mag `null` zijn, en dat is geen slordigheid. `ratio` is leeg als er niets te meten viel of
 * als er te weinig sessies zijn — dan zou het cijfer van één klant zijn. Ook de tellingen zijn leeg
 * zodra de periode verder terugkijkt dan de bewaartermijn: de kolommen bestonden wel, maar de
 * aanmeldingen zijn opgeruimd, dus een nul zou een bewering zijn die niet klopt.
 */
export interface CorrectieRatioRegel {
  flow: string;
  voorgesteld: number | null;
  gecorrigeerd: number | null;
  ratio: number | null;
}

export interface M1Overzicht {
  vanaf: string;
  tot: string;
  perFlow: M1FlowRegel[];
  totaal: Omit<M1FlowRegel, 'flow'>;
  doorlooptijd: T3Regel[];
  correctieRatio: CorrectieRatioRegel[];
  /** De vaste kanttekening bij dit cijfer; het scherm vertaalt hem via zijn eigen sleutel. */
  kanttekening: string;
}

export async function getM1Overzicht(vanaf: string, tot: string): Promise<M1Overzicht> {
  const response = await apiClient.get<{ data: M1Overzicht }>(
    `/intake/metrics/m1?from=${encodeURIComponent(vanaf)}&to=${encodeURIComponent(tot)}`,
  );
  return response.data.data;
}
